// extracted by css-extract-rspack-plugin
module.exports =  {"emptyStateContainer":"BundlesEmptyState__emptyStateContainer___OgiGy","emptyState":"BundlesEmptyState__emptyState___irvtI","boldText":"BundlesEmptyState__boldText___K7l1T"};